import { Chip, Image } from '@ds';
import { PdfUrl } from '@icons';
import { Link } from 'react-router-dom';
import { InvoiceCssTypes } from '@features/components/CaseCard/Blocks/Invoice/types';
import { CardInvoiceStyle } from '@features/components/CaseCard/Blocks/Invoice/constants';
import cn from 'classnames';
import { Invoice } from '@/api/apis/case';
import { useOpenInvoice } from '@/hooks/useOpenInvoice';
import { Uuid } from '@/api/types';

type CardInvoicesProps = {
  invoices: Invoice[];
  caseId: Uuid;
  label?: string;
  style: CardInvoiceStyle;
};

const cssStyles: Record<CardInvoiceStyle, InvoiceCssTypes> = {
  [CardInvoiceStyle.base]: {
    containerClassNames: '',
    fileIconSize: 12,
    counterClassNames: '',
  },
  [CardInvoiceStyle.customized]: {
    containerClassNames: 'gap-2',
    fileIconSize: 16,
    counterClassNames: 'bg-base-55',
  },
};

// This component is not displayed currently, because invoice usually displayed in Case closed status
// which is not displayed on the board
export const CardInvoices = ({ invoices, caseId, label = 'Invoice: ', style }: CardInvoicesProps) => {
  const cssStyle = cssStyles[style];
  const openInvoice = useOpenInvoice(caseId);

  if (!invoices.length) return null;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="w-full" onClick={(e) => e.stopPropagation()}>
      <div className="text-s-cps text-base-20 mb-3">{label}</div>
      <div className="flex items-center gap-1">
        <button
          onClick={openInvoice(invoices[0].id)}
          className={cn(
            'flex items-center border border-solid border-base-20 px-2 py-1 rounded-2xl min-w-0 w-fit max-w-full',
            cssStyle.containerClassNames,
          )}
        >
          <Image height={cssStyle.fileIconSize} className="min-w-3 shrink-0" src={PdfUrl} />
          <div className="text-s-r text-base-5 truncate">{invoices[0].fileName}</div>
        </button>
        {invoices.length > 1 && (
          <Link className="flex items-center" to={`/case/${caseId}#Invoices`}>
            <Chip variant="faded" className={cn('border-none leading-4', cssStyle.counterClassNames)}>
              +{invoices.length - 1}
            </Chip>
          </Link>
        )}
      </div>
    </div>
  );
};
